import React from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { EventObject } from './types';

interface EventBlockProps {
	event: EventObject & { position: number; isVisible: boolean };
	style: React.CSSProperties;
	onClick: () => void;
	userTimezone: string;
	candidateName?: string;
}

export const EventBlock = ({ event, style, onClick, userTimezone, candidateName }: EventBlockProps) => {
	return (
		<div
			className="absolute rounded-md p-1 overflow-hidden text-white shadow-md hover:shadow-lg cursor-pointer transition-all"
			style={style}
			onClick={onClick}
		>
			<div className="h-full overflow-hidden flex flex-col">
				<p className="font-medium text-sm truncate pb-0.5">{event.title}</p>
				<p className="text-xs opacity-90 whitespace-nowrap">
					{formatInTimeZone(event.start, userTimezone, 'HH:mm')} - 
					{formatInTimeZone(event.end, userTimezone, 'HH:mm')}
				</p>
				{candidateName && (
					<p className="text-xs mt-1 opacity-90 line-clamp-1">{candidateName}</p>
				)}
			</div>
		</div>
	);
};
